<dialog class="modal-drawer modal-drawer--{{disposition}}" (click)="closeModal($event)">
    <div class="modal-drawer__content modal-drawer__content--animation-{{this.animationSides}}">
        <div fxLayout="row" style="margin-bottom: 24px;justify-content: flex-end;">
            <a (click)="closeModal($event)" style="align-self:flex-end; text-align: end; cursor: pointer;"><img
                    src="../../../../assets/icons/close.svg" width="15"></a>
        </div>
        <ng-content></ng-content>
    </div>
</dialog>